import React from 'react';
import PropTypes from 'prop-types';
import PreferencesSection from './PreferencesSection';
import Icon from 'SF/MaterialIcon';
import { getWord } from 'utils/tenant';
import { isValidEmail } from 'utils/text';
import Switch from './PreferenceSwitch';
import css from './EmailPreferences.scss';

/**
 * @returns {node} the component for students to configure if they would like to receive
 * notifications at their alternate email address.
 */
const EmailPreferences = ({ correspondenceTo, goToProfileDetails, preferredEmail, setValue }) => {
    const getHeader = () => (
        <span>
            <Icon icon="mail_outline" aria-hidden={true} />
            Email Notifications
            <Switch ariaLabel={"send to my " + getWord('alternateEmail')}
                    checked={correspondenceTo === 'BOTH_MAIL'}
                    disabled={!isValidEmail(preferredEmail)}
                    onChange={(checked) => setValue({correspondenceTo: checked ? 'BOTH_MAIL' : 'SCHOOL_MAIL'})} />
        </span>
    );
    
    const getPreferredEmail = () => {
        if (preferredEmail && isValidEmail(preferredEmail)) return (
            <>
                <label>In addition to my {getWord('institutionEmail', true)}, send to my {getWord('alternateEmail')}:</label>
                <br/>
                <span className={css['email']}>{preferredEmail}</span>
            </>
        );
        
        return (
            <span>
                You can <a href="#" onClick={goToProfileDetails}>provide a valid {getWord('alternateEmail', true)}</a> to receive notifications to a preferred inbox.
            </span>
        );
    };
    
    return (
        <PreferencesSection headerText={getHeader()}
                            className={css['email-options']}>
            {getPreferredEmail()}
        </PreferencesSection>
    )
};

EmailPreferences.propTypes = {
    correspondenceTo: PropTypes.oneOf(['BOTH_MAIL', 'SCHOOL_MAIL']),
    goToProfileDetails: PropTypes.func.isRequired,
    preferredEmail: PropTypes.string,
    setValue: PropTypes.func.isRequired
};

export default EmailPreferences;
